const localeToDate = {
  en: 'en-GB',
  fr: 'fr',
  es: 'es',
  ca: 'ca',
  it: 'it',
  de: 'de',
  nl: 'nl',
  'pt-BR': 'pt-BR',
  'zh-CN': 'zh-CN',
  ko: 'ko',
  ar: 'ar',
  ru: 'ru',
}

export default localeToDate
